import { useMemo } from 'react';

import type { InviteInput, InviteResult } from '@atlassian/expansion-services/invite';
import type { FetchInput, FetchResponse, Product } from '@atlassian/expansion-services/services';
import { invite as inviteService } from '@atlassian/expansion-services/invite';

import { useService } from '@confluence/expansion-services';
import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { ResolvedService, AbstractServiceMarker } from '@atlassian/expansion-services/types';

export const useInvite = (): ResolvedService<
	InviteInput,
	{
		createAnalyticsEvent: CreateUIAnalyticsEvent & AbstractServiceMarker;
		fetchJSON: (<Response>(input: FetchInput) => Promise<FetchResponse<Response>>) &
			AbstractServiceMarker;
		getCurrentCloudId: (() => string) & AbstractServiceMarker;
		getCurrentProduct: (() => Product) & AbstractServiceMarker;
		getCurrentUserId: (() => string) & AbstractServiceMarker;
		getStargateURL: (url: `/${string}`) => string;
	},
	Promise<InviteResult[]>
> => {
	const deps = useMemo(() => ({}), []);
	return useService(inviteService, deps);
};
